export default function(state, payload){
  const {id} = payload;
  state.targetedCampaign = id || null;
  return {...state}
}